"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_webview_1 = require("react-native-webview");
const colors_1 = require("../../common/colors");
const AppText_1 = require("../../component/AppText");
const Stack_1 = __importDefault(require("../../component/ui-components/Stack"));
// Get started screen
const WebPage = ({ route }) => {
    if (!route?.params?.link)
        return ((0, jsx_runtime_1.jsx)(Stack_1.default, { children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.WHITE_SECONDARY, children: "No page url available!" }) }));
    return ((0, jsx_runtime_1.jsx)(react_native_webview_1.WebView, { pullToRefreshEnabled: true, source: { uri: route?.params?.link }, style: { flex: 1, marginTop: 30, backgroundColor: colors_1.Colors.DARK_700 }, containerStyle: {
            backgroundColor: colors_1.Colors.DARK_700,
            padding: 10,
        }, 
        // startInLoadingState={false}
        // originWhitelist={["*"]}
        // javaScriptEnabled={false}
        injectedJavaScript: `const meta = document.createElement('meta'); meta.setAttribute('content', 'width=width, initial-scale=0.5, maximum-scale=0.5, user-scalable=2.0'); meta.setAttribute('name', 'viewport'); document.getElementsByTagName('head')[0].appendChild(meta); ` }));
};
exports.default = (0, react_1.memo)(WebPage);
